<!-- Mobile Backdrop Overlay -->
<div
  *ngIf="isMobileScreen && isMobileOpen"
  class="mobile-backdrop"
  (click)="closeMobile()"
></div>

<aside
  class="sidebar"
  [class.sidebar-collapsed]="isSideBarToggled && !isMobileScreen"
  [class.mobile-open]="isMobileScreen && isMobileOpen"
  [class.mobile-closed]="isMobileScreen && !isMobileOpen"
>
  <!-- Sidebar Header with Integrated Toggle -->
    <div class="sidebar-header">
    <div
      class="logo-box"
      (click)="onLogoClick()"
      [matTooltip]="
        isSideBarToggled && !isMobileScreen ? 'Boxing Reflex Ball' : ''
      "
      matTooltipPosition="right"
    >
     <div class="brand-icon-wrap">
  <img src="/assets/images/logos/brand-logo.png" alt="Boxing Reflex Ball" class="brand-logo-img" />
</div>
      <span class="logo-text" *ngIf="!isSideBarToggled || isMobileScreen"
        >Boxing Reflex Ball</span
      >
    </div>

    <!-- Desktop Collapse Button (Inside Header) -->
    <button
      *ngIf="!isMobileScreen && !isSideBarToggled"
      type="button"
      (click)="sideBarToggle()"
      class="sidebar-toggle-btn"
      matTooltip="Collapse Sidebar"
      matTooltipPosition="right"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>

    <!-- Close button for mobile -->
    <button
      *ngIf="isMobileScreen"
      mat-icon-button
      (click)="closeMobile()"
      class="mobile-close-btn"
      aria-label="Close menu"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Menu Navigation Items -->
  <nav class="menu-list">
    <a
      *ngFor="let item of navItems"
      [routerLink]="[item.route]"
      routerLinkActive="active"
      (click)="onItemClick()"
      class="menu-item"
      [matTooltip]="isSideBarToggled && !isMobileScreen ? item.displayName : ''"
      matTooltipPosition="right"
    >
      <div class="menu-icon-wrap">
        <i class="menu-icon fas" [ngClass]="item.fontAwesomeIcon"></i>
      </div>
      <span class="menu-label" *ngIf="!isSideBarToggled || isMobileScreen">{{
        item.displayName
      }}</span>
    </a>

    <!-- Logout Action Item -->
    <button
      type="button"
      (click)="openLogoutModal()"
      class="menu-item logout-btn-item"
      [matTooltip]="isSideBarToggled && !isMobileScreen ? 'Log Out' : ''"
      matTooltipPosition="right"
    >
      <div class="menu-icon-wrap">
        <mat-icon class="menu-mat-icon">logout</mat-icon>
      </div>
      <span class="menu-label" *ngIf="!isSideBarToggled || isMobileScreen"
        >Log Out</span
      >
    </button>
  </nav>
</aside>
